import React, { Component } from "react";
import { Header, Segment } from "semantic-ui-react";

class HelpLinks extends Component {
  render() {
    return (
      <Segment basic>
        <Header as="h2">
          <a
            href="https://www.dropbox.com/sh/npd30ifxlef6p8b/AAA-vVu7-NT4W0EfHqDF-BKya?dl=0"
            target="_blank"
            rel="noopener noreferrer"
          >
            Raffle Resources
          </a>
          <Header.Subheader>
            A collection of documents to help you manage and execute your raffle
            program.
          </Header.Subheader>
        </Header>
        <Header as="h2">
          <a
            href="https://login.netbanx.com/office/"
            target="_blank"
            rel="noopener noreferrer"
          >
            NetBanx (Paysafe)
          </a>
          <Header.Subheader>
            Our preferred credit card processor. You may login here to manage
            your credit card payments.
          </Header.Subheader>
        </Header>
        <Header as="h2">
          <a
            href="https://gateway.itstgate.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            BridgePay
          </a>
          <Header.Subheader>
            Our previous credit card processor. You may login here to manage
            your credit card payments.
          </Header.Subheader>
        </Header>
      </Segment>
    );
  }
}

export default HelpLinks;
